import { Briefcase, HeartHandshake, Rocket, type LucideIcon } from "lucide-react";

/**
 * One colour per track, everywhere the track record draws it: tiles, badges
 * and the activity chart. Volunteer is the app's volunteer rose (the
 * `volunteer` Button variant, the HeartHandshake icons on volunteer quests).
 * Full class strings, not interpolated, so Tailwind's scanner keeps them.
 */
export type Track = "paid" | "volunteer" | "creator" | "other";

/**
 * Text is the 800 shade on light backgrounds: the tile titles are small
 * labels on a tinted tile, and the 700 tokens only just cleared AA there
 * (amber 4.75:1); 800 reaches AAA 7:1. The semantic tokens stop at 700,
 * hence Tailwind's emerald/rose/amber.
 */
export const TRACK_TEXT: Record<Track, string> = {
  paid: "text-emerald-800 dark:text-success-400",
  volunteer: "text-rose-800 dark:text-rose-300",
  creator: "text-amber-800 dark:text-warning-400",
  other: "text-brand-600 dark:text-brand-400",
};

export const TRACK_BG: Record<Track, string> = {
  paid: "bg-success-500",
  volunteer: "bg-rose-500",
  creator: "bg-warning-400",
  other: "bg-brand-400",
};

/** Badge pills, keyed by badge kind (`worker` is the paid-work track). */
export const BADGE_PILL: Record<"worker" | "volunteer" | "creator", string> = {
  worker: "bg-success-100 text-success-700 dark:bg-success-700/30 dark:text-success-200",
  volunteer: "bg-rose-100 text-rose-700 dark:bg-rose-500/20 dark:text-rose-300",
  creator: "bg-warning-100 text-warning-700 dark:bg-warning-700/30 dark:text-warning-200",
};

/** Soft track tints: the activity chart's count chips. */
export const TRACK_TINT: Record<Track, string> = {
  paid: "bg-success-500/10",
  volunteer: "bg-rose-500/10",
  creator: "bg-warning-400/10",
  other: "bg-brand-400/10",
};

/** The icon each scored track wears on its tile and in the menu strip. */
export const TRACK_ICON: Record<Exclude<Track, "other">, LucideIcon> = {
  paid: Briefcase,
  volunteer: HeartHandshake,
  creator: Rocket,
};
